import PageLayout from "../../../shared/ui/layouts/PageLayout/PageLayout";
import { StickyFilterBar } from "../../../shared/ui/layouts/StickyFilterBar";
import { TimeManagementFilterBar } from "./ui/TimeManagementFilterBar";
import { TimeManagementList } from "./ui/TimeManagementList";
import { CategoryActionMenu } from "./ui/CategoryActionMenu";
import { useAuthStore } from "src/features/auth";
import { useNavItems } from "src/app/layouts/nav/navConfig";
import { useNavigate } from "react-router-dom";
import { routes } from "src/shared/config/routes";

export const ZeitmanagementPage = () => {


  return (
    <PageLayout
      pageTitle="Zeitmanagement"
      headerChildren={<CategoryActionMenu />}
    >
      <div className="flex w-full flex-col gap-4">
        <StickyFilterBar>
          <TimeManagementFilterBar />
        </StickyFilterBar>
        <TimeManagementList />
      </div>
    </PageLayout>
  );
};
